import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "./firebase";

// Call this function whenever an admin action is performed
export async function logActivity({ action, entity, entityId, details, user }) {
  await addDoc(collection(db, "activity_logs"), {
    action,        // e.g. "delete", "edit", "add", "bulk_delete"
    entity,        // e.g. "deity", "content"
    entityId,      // Firestore doc id
    details,       // { field: oldValue -> newValue }
    user,          // admin email or name
    timestamp: Timestamp.now()
  });
}